 import { convfactModuleModel } from './ConvfactModule.model';

export class SubscriptionModel {
  uid: string;
  type: string; 
  expiryDateSubscription: Date;
  isActive: boolean;  
  price: number;
  storageCapacity: number;
  blocked: boolean; 
  monthsToExpiry: number;
  periodicity: string;  
  initialModule: string;
  pagesTotal: number;
  alias: string;
  dateStart: Date;
  dateEnd: Date;

  modules: [convfactModuleModel];

  displayTitle?: string;
  displaySubtitle?: string;
  originalPrice?: number;
  features?: SubscriptionFeatureModel[];
 
  constructor() {
  }
}

export interface SubscriptionFeatureModel {
  description: string;
  included: boolean;
  bold?: boolean;
}
